/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Caricamento in corso...',
	'dlg_close': 'Chiudi',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annulla',
	'dlg_back': 'Torna indietro',
	'dlg_done': 'Fine',
	'dlg_save': 'Salva',

	// Slider
	'sliderRegionLabel': 'Controllo dispositivo di scorrimento, utilizzare le frecce destra e sinistra per spostare le barre del dispositivo di scorrimento.',
	'sliderHandleLabel': 'Barra del dispositivo di scorrimento',
	'a11ySliderHandleLabel': 'Barra del dispositivo di scorrimento %{sliderValue}',
	'sliderInputLabel': 'valore',

	// Side bar
	'sidebarAdd': 'Aggiungi',
	'clearTextFilterValue': 'Annulla',
	'missingDataSetData': 'I dati per questo dataset non sono disponibili. Aggiornare il dataset o rivolgersi all\'amministratore per accedere all\'origine.',

	// Toolbar
	'toolbarRegionLabel': 'Barra degli strumenti',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Famiglia di caratteri',
	'fontFamilyStyle': 'Stile carattere',
	'regularFontStyle': 'Regolare',
	'fontSizeSelect': 'Dimensione carattere',
	'fontColorSelect': 'Colore',
	'fontStyle': 'Stile',
	'colorPickerTitle': 'Selezione di un colore',
	'bold': 'Grassetto',
	'italic': 'Corsivo',
	'underline': 'Sottolineato',
	'fontAlignment': 'Allineamento',
	'justifyLeft': 'Allinea a sinistra',
	'justifyCenter': 'Allinea al centro',
	'justifyRight': 'Allinea a destra',
	'insertOrderedList': 'Elenco ordinato',
	'insertUnorderedList': 'Elenco non ordinato',
	'fontColorPicker': 'Selettore colori',
	'textWrap': 'Testo a capo',
	'restore': 'Ripristina impostazioni predefinite',
	'textAutoFontSize': 'Automatico',
	'textDefaultFontSize': 'Predefinito',
	'textItemTitle': 'Titolo',
	'textLabelShadow': 'Ombreggiatura etichetta',
	'textContrastLabelColor':'Colore di contrasto',
	'toggleOn': 'Su',
	'toggleOff': 'Non attivo',
	'contrastLabelColorInfo': 'Adattare automaticamente il colore dell\'etichetta per l\'accesso facilitato. Questo sostituisce il colore del carattere.',
	'labelShadowInfo':'Aggiungere l\'ombra al testo per l\'accesso facilitato.',
	'applyToAll':'Applica lo stile a tutti gli assi',

	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Numero di risultati (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Percentuale (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Opzione primi elementi o ultimi elementi',
	'topbottomOptionLabel': 'Mostra',
	'searchByLabel': 'Per',
	'searchNoMatches': 'Nessuna corrispondenza trovata',
	'topbottomRankColumnLabel': 'Aggiungi una colonna di classifica alla tabella',
	'topbottomNone': 'Nessuna',
	'topCount': 'Numero massimo',
	'topPercent': '% massima',
	'bottomCount': 'Numero minimo',
	'bottomPercent': '% minima',
	'searchColumn': 'Individuare una colonna',
	'searchColumnAriaLabel': 'Individuare una colonna. Immettere il nome della colonna in base alla quale effettuare la ricerca, quindi utilizzare la freccia in basso per trovare la colonna in un elenco',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Classifica (%{columnLabel})',
	'topbottomClearLabel': 'Reimposta',

	// Format
	'formatAuto': 'Automatico',
	'formatConvertPercent': 'Converti decimali in percentuale',
	'formatAbbreviate': 'Abbrevia',
	'formatUseGrouping': 'Utilizza separatore delle migliaia',
	'dateStyle': 'Stile data',
	'dateTimeStyle': 'Stile Data/Ora',
	'formatMissingValueCharactersInfo': 'I caratteri di valore mancanti specificano i caratteri da visualizzare quando manca il valore..',
	'currencySymbolLabel': 'Simbolo valuta',
	'customSymbolPlaceholder': 'Aggiungi un simbolo',
	'customSymbolLabelInfo': 'Specifica un carattere o caratteri da utilizzare come simbolo personalizzato. Questo simbolo precederà il numero e qualsiasi segno.',
	'numberLabel': 'Etichetta del numero',
	'numberPositionLabel': 'Posizione etichetta',
	'negativeSignPosition': 'Posizione segno negativo',
	'negativeSign': 'Simbolo segno negativo',
	'numberLabelInfo': 'Specifica un\'etichetta per il numero formattato e inserito come prefisso o suffisso a seconda della posizione dell\'etichetta.',
	'nullValueDefault': '<predefinito>',
	'nullValueContent': '(nessun valore)',
	'default': 'Impostazione predefinita',
	'beginning': 'Inizio',
	'end': 'Fine',
	'formatLabel': 'Selezionare un formato',

	// More data indicator
	'moreDataIndicator': 'I dati sono stati ritagliati in %{threshold} elementi. Applicare un filtro per mostrarne di meno.',

	// Expanded View / Focus mode
	'evCollapse': 'Comprimi',
	'duplicate': 'Duplica',
	'copyOf': 'Copia di %{name}',
	'unableToDuplicateBoard': 'Impossibile duplicare "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Impossibile caricare gli oggetti.',

	// Custom widgets
	'customWidget': 'Widget personalizzato',

	// Auto group
	'group': 'Raggruppa',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Sottile',
	'textFontFamilySubClassThin': 'Sottile',
	'textFontFamilySubClassThinItalic': 'Corsivo sottile',
	'textFontFamilySubClassExtraLight': 'Chiarissimo',
	'textFontFamilySubClassExtraLightItalic': 'Corsivo chiarissimo',
	'textFontFamilySubClassLight': 'Chiaro',
	'textFontFamilySubClassLightItalic': 'Corsivo chiaro',
	'textFontFamilySubClassRegular': 'Regolare',
	'textFontFamilySubClassRegularItalic': 'Corsivo regolare',
	'textFontFamilySubClassItalic': 'Corsivo',
	'textFontFamilySubClassMedium': 'Medio',
	'textFontFamilySubClassMediumItalic': 'Corsivo medio',
	'textFontFamilySubClassHeavy': 'Pesante',
	'textFontFamilySubClassHeavyItalic': 'Corsivo pesante',
	'textFontFamilySubClassDemiBold': 'Mezzo grassetto',
	'textFontFamilySubClassDemiBoldItalic': 'Corsivo mezzo grassetto',
	'textFontFamilySubClassBold': 'Grassetto',
	'textFontFamilySubClassBoldItalic': 'Corsivo grassetto',
	'textFontFamilySubClassExtraBold': 'Grassetto scuro',
	'textFontFamilySubClassExtraBoldItalic': 'Corsivo scuro',
	'textFontFamilySubClassBlack': 'Nero',
	'textFontFamilySubClassBlackItalic': 'Corsivo Nero',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass
});
